import React, { useState } from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  Typography, 
  Paper, 
  Container,
  CircularProgress,
  Alert,
  Snackbar
} from '@mui/material';
import emailService from '../../utils/emailService';

const EmailTest: React.FC = () => {
  const [email, setEmail] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSendWelcomeEmail = async () => {
    if (!email || !businessName) {
      setError('Vui lòng nhập đầy đủ thông tin');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const result = await emailService.sendPartnerWelcomeEmail(email, businessName);
      
      if (result) {
        setSuccess(true);
      } else {
        setError('Không thể gửi email. Vui lòng kiểm tra console để biết thêm chi tiết.');
      }
    } catch (err) {
      console.error('Lỗi khi gửi email:', err);
      setError('Đã xảy ra lỗi khi gửi email');
    } finally {
      setLoading(false);
    }
  };

  const handleSendPasswordReset = async () => {
    if (!email) {
      setError('Vui lòng nhập địa chỉ email');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      // Sử dụng Cloud Function thay vì Firebase Auth mặc định
      const result = await emailService.sendCustomPasswordResetEmail(email);
      
      if (result) {
        setSuccess(true);
      } else {
        setError('Không thể gửi email đặt lại mật khẩu. Vui lòng kiểm tra console để biết thêm chi tiết.');
      }
    } catch (err) {
      console.error('Lỗi khi gửi email đặt lại mật khẩu:', err);
      setError('Đã xảy ra lỗi khi gửi email đặt lại mật khẩu');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSuccess(false);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Test Chức Năng Gửi Email
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Thông tin Email
          </Typography>

          <TextField
            label="Email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />

          <TextField
            label="Tên doanh nghiệp"
            fullWidth
            margin="normal"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            disabled={loading}
          />

          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}

          <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSendWelcomeEmail}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : null}
            >
              Gửi Email Chào Mừng
            </Button>

            <Button
              variant="contained"
              color="secondary"
              onClick={handleSendPasswordReset}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : null}
            >
              Gửi Email Đặt Lại Mật Khẩu
            </Button>
          </Box>
        </Box>

        <Typography variant="body2" color="text.secondary">
          Lưu ý: Khi test chức năng, kiểm tra Console để xem logs chi tiết từ Firebase Cloud Functions.
        </Typography>
      </Paper>

      <Snackbar 
        open={success} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          Email đã được gửi thành công!
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default EmailTest; 